import type { ReactNode } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { cn } from '@crossnokaye/ux-common';

import type { DropdownOption } from '@repo/sdk/models/components';
import { ButtonComponentActionConfigVariant } from '@repo/sdk/models/components';

import { ActionDropdownDisplay } from '@/features/equipment-browser/action-components/action-dropdown-display';

interface EquipmentBulkEditTableDropdownCellProps {
  columnId: string;
  disabled?: boolean;
  disableItems?: boolean;
  dropdownOptions?: DropdownOption[];
  tooltipContent?: string;
  rowId: string;
}

export const EquipmentBulkEditTableDropdownCell = ({
  columnId,
  disabled,
  disableItems,
  dropdownOptions = [],
  tooltipContent,
  rowId,
}: EquipmentBulkEditTableDropdownCellProps): ReactNode => {
  const { control } = useFormContext();
  const fieldName = `values.${rowId}.${columnId}`;
  const { field } = useController({
    control,
    name: fieldName,
  });

  return (
    <ActionDropdownDisplay
      data-component="EquipmentBulkEditTableDropdownCell"
      buttonVariant={ButtonComponentActionConfigVariant.Tier2}
      className={cn(
        'w-full text-foreground text-sm [&>span:first-child]:inline-block [&>span:first-child]:overflow-hidden',
        disabled && 'pointer-events-none cursor-not-allowed opacity-50'
      )}
      disabled={disabled}
      disableItems={disableItems}
      onSelect={(option) => field.onChange(option.value)}
      options={dropdownOptions}
      placeholder="Select value ..."
      tooltipContent={disabled || disableItems ? tooltipContent : undefined}
      value={(field.value as string) ?? undefined}
    />
  );
};
